/** Curated conversation themes (keys must match backend ALLOWED_THEMES) */

export const MESSAGE_THEME_OPTIONS = [
  { id: "default", label: "Studio", description: "Classic AnimeHouse" },
  { id: "ocean", label: "Ocean", description: "Cool blue accents" },
  { id: "rose", label: "Rose", description: "Soft pink highlights" },
  { id: "amber", label: "Amber", description: "Warm gold tone" },
  { id: "violet", label: "Violet", description: "Purple night" },
  { id: "slate", label: "Slate", description: "Neutral graphite" },
];

export function getConversationThreadClass(themeKey) {
  switch (themeKey) {
    case "ocean":
      return "bg-[#0a1522]";
    case "rose":
      return "bg-[#160f14]";
    case "amber":
      return "bg-[#14110a]";
    case "violet":
      return "bg-[#100f18]";
    case "slate":
      return "bg-[#0e1014]";
    default:
      return "bg-[#0d1320]";
  }
}

export function getMessageBubbleClasses(themeKey, isOwn) {
  if (isOwn) {
    switch (themeKey) {
      case "ocean":
        return "bg-[#14334a] border-[#2a6a8a] text-white";
      case "rose":
        return "bg-[#3a2432] border-[#6b3d55] text-white";
      case "amber":
        return "bg-[#3a3020] border-[#8a7040] text-white";
      case "violet":
        return "bg-[#2e2450] border-[#5c4d8a] text-white";
      case "slate":
        return "bg-[#252b36] border-[#4a5568] text-white";
      default:
        return "bg-[#1a2b3a] border-[#355268] text-white";
    }
  }
  switch (themeKey) {
    case "ocean":
      return "bg-[#101f2e] border-cyan-500/25 text-white/95";
    case "rose":
      return "bg-[#1c1418] border-rose-500/22 text-white/95";
    case "amber":
      return "bg-[#1c1810] border-amber-500/25 text-white/95";
    case "violet":
      return "bg-[#14121f] border-violet-500/25 text-white/95";
    case "slate":
      return "bg-[#14161c] border-slate-500/30 text-white/95";
    default:
      return "bg-[#121b2a] border-white/10 text-white/95";
  }
}
